import { render, staticRenderFns } from "./ChatCreateRoomModal.vue?vue&type=template&id=810c42a8&scoped=true&"
import script from "./ChatCreateRoomModal.vue?vue&type=script&lang=js&"
export * from "./ChatCreateRoomModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatCreateRoomModal.vue?vue&type=style&index=0&id=810c42a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c42a8",
  null
  
)

export default component.exports